import type { TestContext } from "yup";
import { PROOF_FILE } from "consts/ecommerce";
import { fileType } from "util/validators";
import type { ClientDocument } from "../types";

export function assertDocumentType(this: TestContext, files: Array<ClientDocument> = []) {
    if (files.some((file: ClientDocument) => {
        if (typeof file.documentFileKey === 'string') {
            return false;
        }

        return !fileType(PROOF_FILE.supportedFormats)(file.documentFileKey);
    })) {
        throw this.createError({
            message: 'Unsupported file format'
        });
    }

    return true;
};
